/**
 * The Laksvel parameters a smolt report can include, in the order the report shows them. Chosen
 * when the report is created. `bodyWounds` is the report's wound figures; every other parameter is
 * a Laksvel score card.
 */
export const SMOLT_LAKSVEL_PARAMETERS = [
    'bodyWounds',
    'finDamage',
    'gillLid',
    'scaleLoss',
    'snoutWounds',
    'emaciation',
    'deformity',
    'deformedJaw',
    'skinBleeding',
    'cataract',
    'eyeDamage',
    'maturity',
] as const;

export type SmoltLaksvelParameter = (typeof SMOLT_LAKSVEL_PARAMETERS)[number];

export type ScoredLaksvelParameter = Exclude<SmoltLaksvelParameter, 'bodyWounds'>;

/** The four parameters a new report starts with, and every report made before the choice shows. */
export const DEFAULT_SMOLT_LAKSVEL_PARAMETERS: readonly SmoltLaksvelParameter[] = [
    'bodyWounds',
    'finDamage',
    'gillLid',
    'scaleLoss',
];

/** The chosen parameters in report order, without repeats. */
export function orderLaksvelParameters(
    chosen: readonly SmoltLaksvelParameter[]
): SmoltLaksvelParameter[] {
    const set = new Set(chosen);
    return SMOLT_LAKSVEL_PARAMETERS.filter((parameter) => set.has(parameter));
}
